<template>
  <div class="container">
    <img v-if="direction == 1"
         src="@/assets/woman_back.png" />
    <img v-else
         src="@/assets/woman_face.png" />
    <div class="layout">
      <div class="head"
           @click="e => clickPart(e, '头部')">
        <div class="left">
          <div style="height: 50%;"></div>
          <div style="height: 25%;"
               @click.stop="e => clickPart(e, '耳部')"></div>
          <div style="height: 25%;"></div>
        </div>
        <div class="center"
             @click.stop="e => clickPart(e,  direction == 1 ? '头部' : '面部')">
          <div style="height: 88%;"
               @click.stop="e => clickPart(e, '头部')"></div>
          <div style="width: 80%; height: 13%;"
               @click.stop="e => clickPart(e,  direction == 1 ? '头部' : '眼部')"></div>
          <div style="width: 30%; height: 14%;"
               @click.stop="e => clickPart(e,  direction == 1 ? '头部' : '鼻部')"></div>
          <div style="height: 2%;"></div>
          <div style="width: 40%; height: 10%;"
               @click.stop="e => clickPart(e,  direction == 1 ? '头部' : '口部')"></div>
          <div style="height: 13%;"></div>
        </div>
        <div class="right">
          <div style="height: 50%;"></div>
          <div style="height: 25%;"
               @click.stop="e => clickPart(e, '耳部')"></div>
          <div style="height: 25%;"></div>
        </div>
      </div>
      <div class="neck"
           @click.stop="e => clickPart(e,  direction == 1 ? '颈后部' : '颈部')">
        <div class="left"></div>
        <div class="center">
          <div style="height: 50%"
               @click.stop="e => clickPart(e,  direction == 1 ? '颈后部' : '咽喉')"></div>
        </div>
        <div class="right"></div>
      </div>
      <div class="upper">
        <div class="upper left"
             @click.stop="e => clickPart(e, '上肢')">
        </div>
        <div class="upper center">
          <div class="chest">
            <div class="left"
                 @click.stop="e => clickPart(e, direction == 1 ? '左腰背部' : '右胸部')"></div>
            <div class="center"
                 @click.stop="e => clickPart(e, direction == 1 ? '背部' : '胸骨部')"></div>
            <div class="right"
                 @click.stop="e => clickPart(e, direction == 1 ? '右腰背部' : '左胸部')"></div>
          </div>
          <div class="belly">
            <template v-if="direction == 1">
              <div class="row">
                <div @click.stop="e => clickPart(e, '左腰背部')"></div>
                <div @click.stop="e => clickPart(e, '背部')"></div>
                <div @click.stop="e => clickPart(e, '右腰背部')"></div>
              </div>
              <div class="row">
                <div @click.stop="e => clickPart(e, '左腰部')"></div>
                <div @click.stop="e => clickPart(e, '腰部')"></div>
                <div @click.stop="e => clickPart(e, '右腰部')"></div>
              </div>
            </template>
            <template v-else>
              <div class="row">
                <div @click.stop="e => clickPart(e, '右中上腹部')"></div>
                <div @click.stop="e => clickPart(e, '左中上腹部')"></div>
              </div>
              <div class="row">
                <div @click.stop="e => clickPart(e, '右中上腹部')"></div>
                <div @click.stop="e => clickPart(e, '左中上腹部')"></div>
              </div>
              <div class="row">
                <div @click.stop="e => clickPart(e, '右中上腹部')"></div>
                <div @click.stop="e => clickPart(e, '左中上腹部')"></div>
              </div>
              <div class="row">
                <div @click.stop="e => clickPart(e, '右中下腹部')"></div>
                <div @click.stop="e => clickPart(e, '脐周部')"></div>
                <div @click.stop="e => clickPart(e, '左中下腹部')"></div>
              </div>
              <div class="row">
                <div @click.stop="e => clickPart(e, '右中下腹部')"></div>
                <div @click.stop="e => clickPart(e, '左中下腹部')"></div>
              </div>
            </template>
          </div>
          <div class="genital"
               @click="e => clickPart(e, direction == 1 ? '臀部' : '腹股沟区')">
            <div @click.stop="e => clickPart(e, direction == 1 ? '肛门' : '生殖器')"></div>
          </div>
          <div class="lower"
               @click.stop="e => clickPart(e, '下肢')">
          </div>
        </div>
        <div class="upper right"
             @click.stop="e => clickPart(e, '上肢')">
        </div>
      </div>
      <div class="lower"
           @click.stop="e => clickPart(e, '下肢')">
      </div>
    </div>
  </div>
</template>

<script>
import { bodyList } from '@/api/guidance'

export default {
  name: 'WomanBody',
  props: {
    direction: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      bodyList({
        sex: 2,
        type: 1
      }).then(res => {
        if (res.success && res.code == 200) {
          this.list = res.result
        }
      })
    },
    clickPart(e, partName) {
      // 点击部位
      if (this.list && partName) {
        this.list.forEach(item => {
          if (item.bodyPartsName == partName) {
            this.$emit('clickPart', e, item.id, item.bodyPartsName)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.container img {
  width: calc(50vh - 16px);
  object-fit: contain;
}

.layout {
  position: absolute;
  left: calc(50vw - 25vh + 8px);
  top: 0;
  right: calc(50vw - 25vh + 8px);
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
}

.head {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 11%;
  width: 28%;
  height: 14.5%;
  background-color: red;
}

.head .left {
  width: 18%;
  display: flex;
  flex-direction: column;
  background-color: burlywood;
}

.head .center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: chartreuse;
}

.head .right {
  width: 18%;
  display: flex;
  flex-direction: column;
  background-color: burlywood;
}

.head div div {
  width: 100%;
}

.neck {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 12%;
  height: 3%;
  background-color: green;
}

.neck .left {
  width: 30%;
  background-color: darkblue;
}

.neck .center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: darkmagenta;
}

.neck .right {
  width: 35%;
  background-color: darkblue;
}

.neck div div {
  width: 100%;
}

.upper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 70%;
  height: 34%;
}

.upper.left {
  width: 31%;
  height: 100%;
  background-color: blue;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.upper.center {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

.upper.right {
  width: 31%;
  height: 100%;
  background-color: blue;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.upper.left div {
  width: 100%;
  background-color: tomato;
}

.upper.right div {
  width: 100%;
  background-color: tomato;
}

.chest {
  width: 100%;
  height: 35%;
  background-color: rebeccapurple;
  display: flex;
  flex-direction: row;
}

.chest div {
  flex: 1;
  height: 100%;
}

.chest .center {
  flex: none;
  width: 25%;
}

.chest .left {
  background-color: salmon;
}

.chest .heart {
  margin-left: 10%;
  margin-top: 50%;
  width: 80%;
  height: 30%;
  background: red;
}

.belly {
  width: 100%;
  height: 27%;
  background-color: goldenrod;
  display: flex;
  flex-direction: column;
}

.belly .row {
  flex: 1;
  display: flex;
  flex-direction: row;
  background-color: sandybrown;
}

.belly .row div {
  flex: 1;
  background-color: sienna;
}

.belly .row div:nth-child(2) {
  background-color: springgreen;
}

.genital {
  width: 100%;
  height: 21%;
  background-color: fuchsia;
}

.genital div {
  margin-left: 35%;
  margin-top: 25%;
  width: 30%;
  height: 40%;
  background-color: springgreen;
}

.upper.center .lower {
  width: 100%;
  height: 17%;
  background-color: green;
  display: flex;
  flex-direction: row;
}

.upper.center .lower div {
  flex: 1;
  height: 100%;
}

.lower {
  width: 28%;
  height: 38%;
  background-color: green;
  display: flex;
  flex-direction: column;
}

.lower .row {
  display: flex;
  flex-direction: row;
}

.lower .row div {
  flex: 1;
}

.lower .row div:nth-child(2) {
  background-color: steelblue;
}
</style>